import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Pagination, Navigation, Autoplay } from "swiper/modules";
import "./About.css"; // Custom CSS

const Testimonials = () => {
  const testimonials = [
    {
      name: "Saul Goodman",
      title: "CEO & Founder",
      image: "user5.jpeg", // Replace with actual image URL
      rating: 5,
      quote:
        "Proin iaculis purus consequat sem cure digni ssim donec porttitora entum suscipit rhoncus. Accusantium quam, ultricies eget id.",
    },
    {
      name: "Saul Goodman",
      title: "CEO & Founder",
      image: "user6.jpeg", // Replace with actual image URL
      rating: 5,
      quote:
        "Proin iaculis purus consequat sem cure digni ssim donec porttitora entum suscipit rhoncus. Accusantium quam, ultricies eget id.",
    },
    {
      name: "Saul Goodman",
      title: "CEO & Founder",
      image: "user8.jpeg", // Replace with actual image URL
      rating: 5,
      quote:
        "Proin iaculis purus consequat sem cure digni ssim donec porttitora entum suscipit rhoncus. Accusantium quam, ultricies eget id.",
    },
    {
      name: "Sara Wilson",
      title: "Designer",
      image: "user6.jpeg", // Replace with actual image URL
      rating: 5,
      quote:
        "Export tempor illum tamen malis eram quae irure esse labore quem cillum quid cillum eram malis quorum velit sunt aliqua nostrud.",
    },
    // Add more testimonials as needed
  ];

  return (
    <section id="testimonials" className="testimonials bg-light py-5">
      <div className="container">
        <h2 className="text-center fw-bold mb-4">Testimonials</h2>
        <Swiper
          spaceBetween={30}
          centeredSlides={true}
          autoplay={{
            delay: 3000,
            disableOnInteraction: false,
          }}
          pagination={{
            clickable: true,
          }}
          navigation={true}
          modules={[Pagination, Navigation, Autoplay]}
          className="mySwiper"
        >
          {testimonials.map((testimonial, index) => (
            <SwiperSlide key={index}>
              <div className="testimonial-card bg-white shadow-sm p-4 rounded text-center">
                <img
                  src={testimonial.image}
                  alt={testimonial.name}
                  className="testimonial-img rounded-circle mb-3"
                />
                <h5 className="mb-1">{testimonial.name}</h5>
                <p className="text-muted">{testimonial.title}</p>
                <div className="testimonial-rating mb-3">
                  {Array(testimonial.rating)
                    .fill()
                    .map((_, i) => (
                      <span key={i} className="text-warning">&#9733;</span>
                    ))}
                </div>
                <p className="testimonial-quote text-muted">
                  <i>"{testimonial.quote}"</i>
                </p>
              </div>
              <br></br>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

export default Testimonials;
